import * as client_hooks from '../../../src/hooks.client.js';


export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11')
];

export const server_loads = [];

export const dictionary = {
		"/": [2],
		"/(landing)/bongoCat": [4],
		"/(landing)/dnd": [5],
		"/(landing)/firstSignIn": [6],
		"/(landing)/home": [7],
		"/(landing)/landing-page": [8],
		"/(landing)/markdown": [9],
		"/(landing)/mobile": [10],
		"/(landing)/temp": [11],
		"/(landing)/[trafficSource]": [3]
	};

export const hooks = {
	handleError: client_hooks.handleError || (({ error }) => { console.error(error) }),

	reroute: (() => {})
};

export { default as root } from '../root.svelte';